import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';
import { Action } from 'redux';
import { GetCollaborators } from '../action-creators';
import { CREATE_OWNERSHIP_SUCCESS } from '@webapp/store/ownership/actions';
import { CreateOwnershipSuccess } from '@webapp/store/ownership/action-creators';

export const getCollaboratorsAfterCreateOwnershipEpic = (
  action$: Observable<Action>
) =>
  action$.pipe(
    ofType<Action, CreateOwnershipSuccess>(CREATE_OWNERSHIP_SUCCESS),
    map((action) => {
      return new GetCollaborators(action.ownership.assetId);
    })
  );
